var _g, _path, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_3300)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.4551,
    cy: 12,
    r: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1816 0C5.56464 0 0.181641 5.383 0.181641 12C0.181641 18.617 5.56464 24 12.1816 24C18.7986 24 24.1816 18.617 24.1816 12C24.1816 5.383 18.7986 0 12.1816 0Z",
    fill: "#D2973D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8979 9.27197L9.62129 12.5486L9.46729 14.2729L11.2039 14.1148L14.4705 10.8446L12.8979 9.27197ZM16.3881 8.9255L14.816 7.354L13.6797 8.49034L15.2518 10.063L16.3881 8.9255ZM8.87771 15.4978C8.85963 15.4995 8.84213 15.5001 8.82463 15.5001C8.67063 15.5001 8.52188 15.4394 8.41221 15.3292C8.28971 15.2067 8.22788 15.0363 8.24363 14.8643L8.46471 12.4312C8.48921 12.1646 8.60704 11.9132 8.79663 11.7236L14.0443 6.47534C14.4538 6.06468 15.197 6.08509 15.6286 6.51618L17.2258 8.11334H17.2264C17.6732 8.56076 17.6907 9.27068 17.266 9.69651L12.0178 14.9448C11.8282 15.1349 11.5774 15.2522 11.3102 15.2767L8.87771 15.4978ZM8.82454 16.6665H16.9912C17.312 16.6665 17.5745 16.929 17.5745 17.2498C17.5745 17.5707 17.312 17.8332 16.9912 17.8332H8.82454C8.50371 17.8332 8.24121 17.5707 8.24121 17.2498C8.24121 16.929 8.50371 16.6665 8.82454 16.6665Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_751_3300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 10,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8979 9.27197L9.62129 12.5486L9.46729 14.2729L11.2039 14.1148L14.4705 10.8446L12.8979 9.27197ZM16.3881 8.9255L14.816 7.354L13.6797 8.49034L15.2518 10.063L16.3881 8.9255ZM8.87771 15.4978C8.85963 15.4995 8.84213 15.5001 8.82463 15.5001C8.67063 15.5001 8.52188 15.4394 8.41221 15.3292C8.28971 15.2067 8.22788 15.0363 8.24363 14.8643L8.46471 12.4312C8.48921 12.1646 8.60704 11.9132 8.79663 11.7236L14.0443 6.47534C14.4538 6.06468 15.197 6.08509 15.6286 6.51618L17.2258 8.11334H17.2264C17.6732 8.56076 17.6907 9.27068 17.266 9.69651L12.0178 14.9448C11.8282 15.1349 11.5774 15.2522 11.3102 15.2767L8.87771 15.4978ZM8.82454 16.6665H16.9912C17.312 16.6665 17.5745 16.929 17.5745 17.2498C17.5745 17.5707 17.312 17.8332 16.9912 17.8332H8.82454C8.50371 17.8332 8.24121 17.5707 8.24121 17.2498C8.24121 16.929 8.50371 16.6665 8.82454 16.6665Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_751_3300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.9082,
    y: 5,
    width: 14,
    height: 14,
    fill: "#14232A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_3300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.181641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.8f0068e597b0f3d64cee6e4dfc151c22.svg";
export { ForwardRef as ReactComponent };